import { products } from "../../data/products";
import Button from "../ui/Button";
import Container from "../ui/Container";
import ProductMark from "../ui/ProductMark";
import SectionHeader from "../ui/SectionHeader";
import StatusBadge from "../ui/StatusBadge";

function ProductsPreview({ onNavigate }) {
  const featuredProduct = products.find((product) => product.featured);
  const futureProducts = products.filter((product) => !product.featured).slice(0, 4);

  return (
    <section id="products" className="border-t border-border/70 py-16 sm:py-20">
      <Container>
        <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between">
          <SectionHeader
            title="Products"
            subtitle="A growing ecosystem of products built under Technie."
          />
          <Button variant="secondary" onClick={() => onNavigate("/products")} className="sm:mb-1">
            View Products
          </Button>
        </div>

        {featuredProduct ? (
          <div className="mt-10 rounded-2xl border border-border bg-surface/35 p-5 transition-all duration-200 ease-in-out hover:border-accent/45 sm:p-6">
            <div className="flex flex-col gap-5 sm:flex-row sm:items-start sm:justify-between">
              <div className="flex gap-4">
                <ProductMark label={featuredProduct.logo} />
                <div>
                  <div className="flex flex-wrap items-center gap-3">
                    <h3 className="text-lg font-semibold text-primary">{featuredProduct.name}</h3>
                    <StatusBadge status={featuredProduct.status} />
                  </div>
                  <p className="mt-2 max-w-2xl text-sm leading-6 text-secondary">
                    {featuredProduct.description}
                  </p>
                </div>
              </div>
              <Button
                as="a"
                href={featuredProduct.link}
                target="_blank"
                rel="noreferrer"
                variant="secondary"
                className="shrink-0"
              >
                Visit Product
              </Button>
            </div>
          </div>
        ) : null}

        <div className="mt-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {futureProducts.map((product) => (
            <div
              key={product.id}
              className="rounded-2xl border border-border/80 bg-surface/20 p-4 transition-all duration-200 ease-in-out hover:border-accent/35 hover:bg-surface/30"
            >
              <div className="flex items-center justify-between gap-3">
                <ProductMark label={product.logo} />
                <StatusBadge status={product.status} />
              </div>
              <h3 className="mt-4 text-sm font-semibold text-primary">{product.name}</h3>
              <p className="mt-2 text-sm leading-6 text-secondary">{product.description}</p>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}

export default ProductsPreview;
